<template>
	<div>
		<ValidationObserver ref="login" v-slot="{ invalid, validated, passes }">
			<v-form>
				<ValidationProvider v-slot="{ errors }" name="email" rules="required|email">
					<span class="label">Email</span>
					<v-text-field
						v-model.trim="email"
						:error-messages="errors"
						placeholder="Enter your e-mail address"
						class="remove-padding"
						autofocus
						filled
						required
					/>
				</ValidationProvider>
				<ValidationProvider v-slot="{ errors }" name="password" rules="required|min:8|verify_password">
					<span class="label">Password</span>
					<v-text-field
						v-model.trim="password"
						:error-messages="errors"
						placeholder="Enter your password"
						:type="e1 ? 'password' : 'text'"
						class="remove-padding"
						counter
						filled
						@keyup.enter="passes(submit)"
					>
						<template v-slot:append>
							<eye-icon v-if="e1" style="cursor: pointer;" @click="() => (e1 = !e1)"></eye-icon>
							<eyeoff-icon v-else style="cursor: pointer;" @click="() => (e1 = !e1)"></eyeoff-icon>
						</template>
					</v-text-field>
				</ValidationProvider>
				<div v-if="err.length" class="error-callback">
					<ul>
						<li v-for="error in err" :key="error">{{ error }}</li>
					</ul>
				</div>
				<v-layout justify-space-between align-content-center>
					<v-row>
						<v-col cols="12" sm="6" class="top-row-align">
							<v-btn
								class="white--text override-bg"
								color="#3db0ad"
								:loading="loading"
								:disabled="invalid || !validated || loading"
								@click.prevent="passes(submit)"
							>Login</v-btn>
							<v-spacer/>
						</v-col>
						<v-col cols="12" sm="6" class="bottom-row-align forgot-pw">
							<a href @click.prevent="forgotPassword">Forgot Password</a>
						</v-col>
					</v-row>
				</v-layout>
			</v-form>
		</ValidationObserver>
	</div>
</template>

<script>
	import Auth from "@aws-amplify/auth";
	import Cookies from 'js-cookie';

	export default {
		props: {
			response: { type: Function, default: null }
		},
		data: () => ({
			loading: false,
			err: '',
			e1: true,
			password: "",
			email: ""
		}),
		watch: {
			email: function() {
				this.clearErrors();
			},
			password: function() {
				this.clearErrors();
			}
		},
		methods: {
			checkForQueryString () {
				const urlParams = new URLSearchParams(this.$searchParams.location.search);
				const query = urlParams.get('orgID');

				return query;
			},
			submit() {
				this.loading = true;
				const { email, password } = this;
				// eslint-disable-next-line no-console
				console.log('signIn', email, password)

				// to handle case sensitivity on form submission
				let emailLowerCase = email
					? email.toLowerCase()
					: email;

				Auth.signIn(emailLowerCase, password)
					.then(user => {
						// eslint-disable-next-line no-console
						console.log('login okay...', user);
						const loginCredentials = {
								email: email,
								password: password
							}

						this.$emit('storeCreds', loginCredentials)
						
						Auth.currentSession().then(async session => {
							// eslint-disable-next-line no-console
							console.log('session info', session)
							const token = session.refreshToken.token
							const domain = process.env.VUE_APP_cookie_domain || 'cameramatics.com'
							const name = process.env.VUE_APP_cookie_name || 'CameraMaticsToken'
							const accessToken = session.accessToken.jwtToken
							// eslint-disable-next-line no-console
							console.log(domain)
							// eslint-disable-next-line no-console
							console.log(name)

							Cookies.set(name, token, { expires: 7, domain: domain })
							Cookies.set('accessToken', accessToken, { expires: 7, domain: domain })
							this.response(user, this.checkForQueryString())
							
						}).catch(err => {
							// eslint-disable-next-line no-console
							console.log('could not set cookies...', err)
							this.response(user, this.checkForQueryString())
						})
					})
					.catch(err => {
						// eslint-disable-next-line no-console
						console.log('login failed...', err);
						this.loading = false;
						this.err = [err.message];
					});
			},
			forgotPassword() {
				this.$emit("auth-state", {
					type: "ForgotPassword",
					email: this.email || ""
				});
			},
			clearErrors() {
				if (this.err.length > 0) {
					this.err = [];
				}
			}
		}
	};
</script>

<style lang="scss" >
		.top-row-align {
			text-align: left;
		}

		.bottom-row-align {
			text-align: right;
		}

		.label {
			display: block;
			text-align: left;
			color: white;
			font-size: 1rem;
			font-weight: 400;
			padding-bottom: 0.5em;
		}

		.forgot-pw {
			a {
				color: white !important;
			}
		}

	@media only screen and (max-width: 599px) {
		.top-row-align {
			text-align: center;
		}

		.bottom-row-align {
			text-align: center;
		}
	}


	.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn-outlined) {
		color: grey !important;
		background-color: white !important;
	}
	.remove-padding {
		margin-top: 0 !important;
		padding-top: 0 !important;
	}
	.theme--light.v-counter {
    color: white !important;
}
</style>
